<script>
import { format, parseISO } from 'date-fns/fp'
import { authComputed, authMethods } from '@state/helpers'

export default {
  name: 'AdminTableItem',
  props: {
    tableType: { type: String, required: false, default: '' },
    itemData: { type: Object, required: true },
    tableFields: { type: Array, required: true },
    noEditBtn: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      deleteWarningFlag: false,
    }
  },
  computed: {
    ...authComputed,
    companyId() {
      return this.$route.params.companyId
    },
    groupId() {
      return this.$route.params.groupId
    },
    formattedDate() {
      return format('M/d/yy h:mma', parseISO(this.itemData.updated_at))
    },
    isPendingCompany() {
      var found = false
      if (this.itemData.company_invites) {
        this.itemData.company_invites.forEach((invite, key) => {
          if (
            found === false &&
            +invite.company_id === +this.companyId &&
            invite.status === 'new'
          ) {
            found = true
          }
        })
      }
      return found
    },
    isPendingGroup() {
      var found = false
      if (this.itemData.group_invites) {
        this.itemData.group_invites.forEach((invite, key) => {
          if (
            found === false &&
            +invite.group_id === +this.groupId &&
            invite.status === 'new'
          ) {
            found = true
          }
        })
      }
      return found
    },
  },
  methods: {
    ...authMethods,
    goEditItem() {
      this.$emit('go-edit-item', this.itemData)
    },
    onClose() {
      this.deleteWarningFlag = false
    },
    deleteItemDialog() {
      this.deleteWarningFlag = true
    },
    deleteItem() {
      this.$emit('delete-item', this.itemData.id)
      this.deleteWarningFlag = false
    },
    updateOrderStatus(event, orderId) {
      this.$emit('update-order-status', {
        newStatus: event.target.value,
        orderId: orderId,
      })
    },
  },
}
</script>

<template>
  <div class="table-row h-10 even:bg-gray-lighter">
    <div
      v-for="(data, index) in tableFields"
      :key="index"
      :class="[data.class]"
    >
      <div v-if="data.displayField === 'name'" class="flex items-center">
        <div class="w-4 h-4 mr-2 rounded-full overflow-hidden">
          <img class="w-full" :src="itemData.image_url" />
        </div>
        {{ itemData.name }}
      </div>
      <div
        v-else-if="
          data.displayField === 'status' &&
            (canManageCompanies() || canEditCompany(itemData.company_id))
        "
        class="flex items-center"
      >
        <select
          v-model="itemData[data.displayField]"
          @change="updateOrderStatus($event, itemData['id'])"
        >
          <option value="ordered">Ordered</option>
          <option value="received">Received</option>
          <option value="pending">Pending</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select> </div
      ><div
        v-else-if="
          data.displayField === 'status' &&
            !(canManageCompanies() || canEditCompany(itemData.company_id))
        "
        class="flex items-center"
      >
        {{ itemData[data.displayField] }}
      </div>
      <div
        v-else-if="
          data.displayField === 'updated_at' ||
            data.displayField === 'created_at' ||
            data.displayField === 'status_update_at'
        "
      >
        {{ formattedDate }}
      </div>
      <div
        v-else-if="data.displayField === 'Actions'"
        class="flex items-center justify-end"
      >
        <button
          class="text-blue text-3xl cursor-pointer focus:outline-none"
          @click="deleteItemDialog"
        >
          ✕
        </button>

        <div
          v-if="isPendingCompany || isPendingGroup"
          class="w-5 h-5 leading-normal text-gray text-center ml-2 text-xl border border-gray-dark rounded-full relative"
        >
          <span class="absolute left-0 top-0 leading-3 text-center w-full"
            >...</span
          >
        </div>

        <svg
          v-if="!noEditBtn"
          class="tooltip-target cursor-pointer ml-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 1000.23"
          fill="#069BD7"
          height="22"
          width="22"
          @click="goEditItem"
        >
          <title>Kyndhub edit icon</title>
          <path
            d="M499.86,315.82c101.73,0,184.22,82.43,184.25,184.16v.09c0,101.73-82.43,184.22-184.16,184.25h-.09a184.25,184.25,0,0,1,0-368.5Zm0,52.65A131.58,131.58,0,1,0,631.55,500h0A131.6,131.6,0,0,0,500,368.42h-.09ZM805.4,693.93a26.29,26.29,0,0,1-4.62-31.2,338.44,338.44,0,0,0,26.76-65A26.32,26.32,0,0,1,852.73,579h94.44V421.12h-94.3a26.29,26.29,0,0,1-25.19-18.77,338.7,338.7,0,0,0-26.76-65,26.29,26.29,0,0,1,4.62-31.2l66.65-66.7L760.56,127.83l-66.79,66.79a26.31,26.31,0,0,1-31.16,4.63,341.46,341.46,0,0,0-65-26.81,26.35,26.35,0,0,1-18.76-25.24V52.81H420.91V147.2a26.35,26.35,0,0,1-18.77,25.24,342,342,0,0,0-65,26.81A26.3,26.3,0,0,1,306,194.62L239.35,128,127.67,239.46l66.65,66.65A26.33,26.33,0,0,1,199,337.32a337.57,337.57,0,0,0-26.77,65A26.3,26.3,0,0,1,147,421.07H52.46V579H146.9a26.32,26.32,0,0,1,25.19,18.77,338.44,338.44,0,0,0,26.76,65,26.29,26.29,0,0,1-4.62,31.2l-66.65,66.66L239.21,872.22l66.65-66.66A26.31,26.31,0,0,1,337,800.94,338,338,0,0,0,402,827.7a26.35,26.35,0,0,1,18.86,25.24v94.43h158V852.94a26.35,26.35,0,0,1,18.86-25.24,338,338,0,0,0,64.94-26.76,26.31,26.31,0,0,1,31.16,4.62l66.65,66.66L872.19,760.58Zm50.84-23.71L928,742a26.3,26.3,0,0,1,0,37.2h0L779.14,928.05a26.34,26.34,0,0,1-37.21,0l-71.78-71.78a392.43,392.43,0,0,1-38.6,15.85V973.81a26.35,26.35,0,0,1-26.3,26.31H394.61a26.35,26.35,0,0,1-26.3-26.31V872.12a392.43,392.43,0,0,1-38.6-15.85l-71.78,71.78a26.34,26.34,0,0,1-37.21,0L71.88,779.21a26.3,26.3,0,0,1,0-37.19l0,0,71.74-71.78a392.5,392.5,0,0,1-15.86-38.6H26.3A26.3,26.3,0,0,1,0,605.32H0V394.77a26.36,26.36,0,0,1,26.3-26.3H128a392.5,392.5,0,0,1,15.86-38.6L72.11,258.09a26.31,26.31,0,0,1,0-37.2h0L221,72a26.36,26.36,0,0,1,37.21,0l71.55,71.79a395.25,395.25,0,0,1,38.6-15.9V26.19A26.35,26.35,0,0,1,394.61-.12H605.16a26.36,26.36,0,0,1,26.3,26.31V127.88a395.25,395.25,0,0,1,38.6,15.9L741.84,72a26.36,26.36,0,0,1,37.21,0L927.89,220.88a26.3,26.3,0,0,1,0,37.19l0,0-71.74,71.78A392.5,392.5,0,0,1,872,368.47H973.7a26.36,26.36,0,0,1,26.3,26.3V605.32a26.3,26.3,0,0,1-26.3,26.3H872.19a390.36,390.36,0,0,1-16,38.6Z"
            transform="translate(0 0.12)"
          />
        </svg>
      </div>
      <div v-else>
        {{ itemData[data.displayField] }}
      </div>
    </div>

    <BaseModalWindow
      v-if="deleteWarningFlag"
      modalcls="w-user-edit bg-white rounded-xl mx-auto px-11 shadow-box relative left-0 flex justify-between overflow-hidden"
      :visible="deleteWarningFlag"
      @close="onClose"
    >
      <template v-slot:body>
        <div class="w-full mx-auto mt-12 mb-5">
          <div>Are you sure to delete {{ itemData.name }}?</div>
          <div class="mt-6">
            <button
              class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mr-4"
              @click="deleteItem"
            >
              Confirm
            </button>
            <button
              class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button ml-4"
              @click="onClose"
            >
              Cancel
            </button>
          </div>
        </div>
      </template>
    </BaseModalWindow>
  </div>
</template>
